// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".secure-privacy-tb-lower-right{display:none!important}", "",{"version":3,"sources":["webpack://./resources/js/Layouts/AppFooter.vue"],"names":[],"mappings":"AACI,+BACI,sBAAR","sourcesContent":["\n    .secure-privacy-tb-lower-right {\n        display: none !important;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
